import './RANetworthPercentageSlider.scss';
import React from 'react';
const Slider = require('rc-slider').default;
const classNames = require('classnames');
import PropTypes from 'prop-types';
import { InfoTooltip } from 'components/tooltip/tooltip';
import coin from '../../../../assets/icons/coin.svg';
import arrow from '../../../../assets/icons/dropdown_down.svg';
import { formatText } from 'core/i18n';
import { isInternetExplorer, isWindows } from 'utilities/browser';

const blueColor = '#002b45';
const buildLabelStyles = () => ({
    width: 200,
    textAlign: 'left',
    marginLeft: 10,
    color: blueColor,
    fontSize: 13,
});
const MIN_VALUE = 1;
const MAX_VALUE = 4;

class RANetworthPercentageSlider extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleLooseChange = this.handleLooseChange.bind(this);
    }

    handleChange(value) {
        if (value < MIN_VALUE || value > MAX_VALUE) {
            return;
        }
        const marks = this.getMarks();
        this.props.changeSelectedOption(value);
        this.props.recordEventSliderChange(marks[value].label);
    }

    handleLooseChange(value) {
        this.props.changeSelectedOption(value);
    }

    getMarks() {
        const { value, steps } = this.props;
        const marks = steps.reduce((acc, step) => {
            acc[step.id] = { label: step.label, style: buildLabelStyles() };
            if (step.id == value) {
                acc[value].style.fontWeight = 'bold';
                acc[value].style.fontSize = '18px';
            }

            return acc;
        }, {});

        return marks;
    }

    buildCoinArrow() {
        const { value } = this.props;
        const top = `${-5 + value}px`;

        return <img className="ra-networth-percentage-slider__arrow" src={arrow} style={{ top }} />;
    }

    buildCoins() {
        const { value } = this.props;
        const coins = [];
        const coinsQuantity = 10;

        for (let i = 0; i < coinsQuantity; i++) {
            const modifier = i < value * 2 ? 'enabled' : 'disabled';

            coins.push(
                <div key={i} className="ra-networth-percentage-slider__coin">
                    <img
                        className={`ra-networth-percentage-slider__coin-image ra-networth-percentage-slider__coin-image--${modifier}`}
                        src={coin}
                    />
                </div>
            );
        }

        return coins.reverse();
    }

    buildLooseCoins() {
        const { value } = this.props;
        const coins = [];

        for (let i = 0; i < 4; i++) {
            const modifier = i < value ? 'enabled' : 'disabled';

            coins.push(
                <div key={i} className="ra-networth-percentage-slider__coin">
                    <img
                        className={`ra-networth-percentage-slider__coin-image ra-networth-percentage-slider__coin-image--${modifier}`}
                        src={coin}
                    />
                </div>
            );
        }

        return coins.reverse();
    }

    getSliderLooseLabels() {
        const labels = this.props.steps.map((option, i) => {
            const labelClassName = classNames('ra-networth-percentage-slider__labels__number', {
                'ra-networth-percentage-slider__labels__number--hidden': this.props.value !== option.id,
            });

            return (
                <div className={labelClassName} key={i}>
                    {option.label}
                </div>
            );
        });

        return <div className="ra-networth-percentage-slider__labels hidden-lg hidden-md hidden-sm">{labels}</div>;
    }

    render() {
        const { value, titleText, disabled, recordEventTooltipClick } = this.props;
        const marks = this.getMarks();
        const coins = this.buildCoins();
        const looseCoins = this.buildLooseCoins();
        const sliderLooseLabels = this.getSliderLooseLabels();
        const msieCondition = isInternetExplorer() && isWindows();
        const sliderDesktopClass = classNames('ra-networth-percentage-slider__left hidden-xs', { msie: msieCondition });

        return (
            <div className="ra-networth-percentage-slider">
                <div className="ra-networth-percentage-slider__head">
                    <div className="ra-networth-percentage-slider__title">
                        <h2>
                            {titleText}
                            <div className="tooltip-wrapper" onClick={recordEventTooltipClick}>
                                <InfoTooltip text={formatText('suitabilityTest-tooltipNineQuestion')} />
                            </div>
                        </h2>
                    </div>
                </div>

                <div className="ra-networth-percentage-slider__container">
                    <div className={sliderDesktopClass}>{coins}</div>
                    <div className="ra-networth-percentage-slider__left visible-xs">{looseCoins}</div>
                    <div className="ra-networth-percentage-slider__right hidden-xs">
                        <Slider
                            className="ra-networth-percentage-slider__rc-slider"
                            disabled={disabled}
                            marks={marks}
                            max={MAX_VALUE + 1}
                            min={MIN_VALUE - 1}
                            onChange={this.handleChange}
                            tipFormatter={null}
                            value={value}
                            vertical
                        />
                    </div>
                    <div className="ra-networth-percentage-slider__loose visible-xs">
                        {sliderLooseLabels}
                        <Slider
                            disabled={disabled}
                            dots
                            max={4}
                            min={1}
                            onChange={this.handleLooseChange}
                            step={1}
                            value={value}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

RANetworthPercentageSlider.propTypes = {
    changeSelectedOption: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    steps: PropTypes.array,
    titleText: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    recordEventSliderChange: PropTypes.func,
    recordEventTooltipClick: PropTypes.func,
};

module.exports = RANetworthPercentageSlider;
